module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/protocolo-tipo/protocolo-tipo.component.css
// module id = ./src/app/protocolo-tipo/protocolo-tipo.component.css
// module chunks = main